import React, { createContext, useContext, useState } from "react";

interface OutlineContextType {
  isOutlineGenerated: boolean;
  setIsOutlineGenerated: React.Dispatch<React.SetStateAction<boolean>>;
}

const OutlineContext = createContext<OutlineContextType | undefined>(undefined);

export const OutlineProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOutlineGenerated, setIsOutlineGenerated] = useState(false);

  return (
    <OutlineContext.Provider value={{ isOutlineGenerated, setIsOutlineGenerated }}>
      {children}
    </OutlineContext.Provider>
  );
};

export const useOutlineContext = () => {
  const context = useContext(OutlineContext);
  if (!context) {
    throw new Error("useOutlineContext must be used within an OutlineProvider");
  }
  return context;
};
